<template>
  <div></div>
</template>

<script>
  import Constants from '@/common/constants';

  export default {
    name: 'ErrorPage',
    mounted() {
      Constants.alert
        .fire(
          'Сессия завершена',
          'Извините, но Ваша сессия завершена. Пожалуйста, войдите в систему заново.',
          'warning',
        )
        .then(() => {
          this.$router.push({ name: 'Login' });
        });
    },
  };
</script>
